export const GET_DEVICE_ID = `
  query getDeviceId {
    getDid {
      statusCode
      message
      data {
        did
      }
    }
  }
`;

export const REFRESH_TOKEN = `
  mutation refreshToken {
    refreshToken {
      statusCode
      message
      data {
        rtk
        atk
      }
    }
  }
`;

export const REQUEST_TV_LOGIN = `
  query requestLoginTv {
    requestTvLogin {
      statusCode
      message
      data {
        isValidFor
        requestId
      }
    }
  }
`;

export const REQUEST_LOGIN = `
  query requestLogin($phone: String!) {
    requestLogin(mobile: $phone) {
      statusCode
      message
    }
  }`;

export const GET_LOGIN_STATUS = `
  query checkLoginStatus($requestId: String!) {
    checkLoginStatus(requestId: $requestId) {
      statusCode
      message
      data {
        atk
        rtk
      }
    }
  }
`;

export const LOGOUT = `
  mutation logout {
    logout {
      statusCode
      message
    }
  }
`;

export const GET_USER_SUBSCRIPTION_DETAIL = `
  query getUserSubscriptionDetails {
    getUserSubscriptionDetails {
      status {
        message
        statusCode
      }
      data {
        remainingDays
        latestSubscription {
          id
          userId
          subscriptionPlanId
          status
          startsIn
          endsIn
          price
          updatedAt
          createdAt
          extendedTime
        }
      }
    }
  }
`;

export const LOGIN = `
query login($phone: String!, $code: String!) {
  login(mobile: $phone, code: $code) {
    statusCode
    message
    data {
      atk
      rtk
      tmt
    }
  }
}`;

export const GET_ALL_DEVICES = `
query getAllDevices {
  getAllDevices {
    statusCode
    message
    data {
      metadata
      id
    }
  }
}`;

export const TERMINATE_DEVICE = `
mutation terminateDeviceTmt($did: String!) {
    logoutDevices(did: $did) {
      statusCode
      message
    }
  }`;

export const SEND_PURCHASE_LINK = `
  query sendPurchaseLink {
    sendPurchaseLink {
      statusCode
      message
      data {
        remaining
      }
    }
  }
`;

export const HAS_RECENT_PAYMENT = `
query hasRecentSubscriptionPayment {
  hasRecentSubscriptionPayment {
    message
    statusCode
    error
  }
}
`;

export const GET_PURCHASE_CODE = `
query getPurchaseCode{
  getPurchaseCode {
    statusCode
    message
    data {
      remaining
      code
    }
  }
}
`;
